// extracted by mini-css-extract-plugin
export default {"wrapper":"Ap-z","response":"Bp-z","error":"Cp-z","disabled":"Dp-z","buttons":"Ep-z","feedbackQuestionSection":"Fp-z","yesNoWrapper":"Gp-z"};